import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import I18n from 'I18n';
import ObjectTypeSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/ObjectTypeSelectionPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ObjectTypeStep({
  subHeading,
  objectTypeId,
  setObjectTypeId,
  setValidationMessage,
  selectedTriggerOption,
  onSelectTriggerOption,
  goToNextStep
}) {
  useEffect(() => {
    setObjectTypeId(UNKNOWN_ID);
    setValidationMessage(I18n.text('createWorkflow.selectRequiredObjectTypeTooltip'));
  }, [setObjectTypeId, setValidationMessage]);
  return /*#__PURE__*/_jsx(ObjectTypeSelectionPanel, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "createWorkflow.manualEnrollmentHeader"
    }),
    subHeading: subHeading,
    objectTypeId: objectTypeId,
    setObjectTypeId: newObjectTypeId => {
      setObjectTypeId(newObjectTypeId);
      setValidationMessage(null);
      goToNextStep();
    },
    stagedTriggerOption: selectedTriggerOption,
    onSelectTriggerOption: onSelectTriggerOption
  });
}
export const objectTypeStep = {
  component: ObjectTypeStep,
  getLabel: () => I18n.text('createWorkflow.step.eligibility')
};